import { Link, useLocation } from "react-router-dom";

const BottomBarMenu = [
  {
    name: "Courses",
    icon: (
      <svg
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 3.5H2C1.17157 3.5 0.5 4.17157 0.5 5V13C0.5 13.8284 1.17157 14.5 2 14.5H14C14.8284 14.5 15.5 13.8284 15.5 13V5C15.5 4.17157 14.8284 3.5 14 3.5Z"
          
        />
        <path
          d="M8.5 1V2.5H7.5V1C7.5 0.867392 7.55266 0.740192 7.64642 0.646423C7.74019 0.552655 7.86739 0.5 8 0.5C8.13261 0.5 8.25981 0.552655 8.35358 0.646423C8.44734 0.740192 8.5 0.867392 8.5 1Z"
          
        />
        <path
          d="M14.35 17.35C14.3049 17.3974 14.2506 17.4352 14.1904 17.461C14.1303 17.4868 14.0655 17.5002 14 17.5002C13.9345 17.5002 13.8697 17.4868 13.8096 17.461C13.7494 17.4352 13.6951 17.3974 13.65 17.35L11.8 15.5H13.2L14.35 16.65C14.3974 16.6951 14.4352 16.7494 14.4611 16.8096C14.4869 16.8697 14.5002 16.9345 14.5002 17C14.5002 17.0655 14.4869 17.1303 14.4611 17.1904C14.4352 17.2506 14.3974 17.3049 14.35 17.35V17.35Z"
          
        />
        <path
          d="M4.20001 15.5L2.34998 17.35C2.30486 17.3974 2.2506 17.4352 2.19043 17.461C2.13026 17.4868 2.06547 17.5002 2 17.5002C1.93453 17.5002 1.86974 17.4868 1.80957 17.461C1.7494 17.4352 1.69514 17.3974 1.65002 17.35C1.60258 17.3049 1.56481 17.2506 1.539 17.1904C1.51319 17.1303 1.49988 17.0655 1.49988 17C1.49988 16.9345 1.51319 16.8697 1.539 16.8096C1.56481 16.7494 1.60258 16.6951 1.65002 16.65L2.79999 15.5H4.20001Z"
          
        />
      </svg>
    ),
    path: "/tutors/65c7413374027789ccfff261",
  },
  {
    name: "My Courses",
    icon: (
      <svg
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.999 0.617997H1.999C1.46856 0.617997 0.959856 0.828709 0.584784 1.20378C0.209711 1.57885 -0.00100319 2.08756 -0.00100319 2.618V15.38C-0.00167732 15.7218 0.0852448 16.058 0.251469 16.3567C0.417693 16.6553 0.657672 16.9063 0.948507 17.0859C1.23934 17.2654 1.57133 17.3674 1.91279 17.3821C2.25424 17.3968 2.59378 17.3238 2.899 17.17L7.108 15.07C7.38586 14.931 7.69229 14.8586 8.003 14.8586C8.3137 14.8586 8.62014 14.931 8.898 15.07L13.107 17.17C13.4122 17.3238 13.7517 17.3968 14.0932 17.3821C14.4347 17.3674 14.7667 17.2654 15.0575 17.0859C15.3483 16.9063 15.5883 16.6553 15.7545 16.3567C15.9207 16.058 16.0077 15.7218 16.007 15.38V2.618C16.007 2.35468 15.955 2.09395 15.854 1.85078C15.753 1.6076 15.605 1.38677 15.4184 1.20095C15.2318 1.01513 15.0104 0.867975 14.7668 0.767937C14.5232 0.6679 14.2623 0.616944 13.999 0.617997ZM11.35 6.07501L7.703 9.721C7.51547 9.90847 7.26116 10.0138 6.996 10.0138C6.73083 10.0138 6.47652 9.90847 6.289 9.721L4.65 8.07501C4.60357 8.02852 4.56676 7.97334 4.54167 7.91262C4.51657 7.85191 4.50367 7.78684 4.50372 7.72114C4.50377 7.65544 4.51675 7.5904 4.54194 7.52972C4.56712 7.46904 4.60401 7.41392 4.6505 7.3675C4.69699 7.32108 4.75216 7.28426 4.81288 7.25916C4.87359 7.23407 4.93865 7.22117 5.00435 7.22122C5.07005 7.22126 5.13509 7.23425 5.19577 7.25944C5.25645 7.28462 5.31157 7.32152 5.358 7.368L7.004 9.014L10.65 5.368C10.6964 5.32152 10.7515 5.28462 10.8122 5.25944C10.8729 5.23425 10.9379 5.22126 11.0036 5.22122C11.0693 5.22117 11.1344 5.23407 11.1951 5.25916C11.2558 5.28426 11.311 5.32108 11.3575 5.3675C11.404 5.41392 11.4409 5.46904 11.4661 5.52972C11.4912 5.5904 11.5042 5.65544 11.5043 5.72114C11.5043 5.78684 11.4914 5.85191 11.4663 5.91262C11.4412 5.97334 11.4044 6.02852 11.358 6.07501H11.35Z"
          
        />
      </svg>
    ),
    path: "/profile#mycourses",
  },

  {
    name: "Home",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.157 2.05005L1.162 3.9231C0.999942 4.22786 0.919508 4.56937 0.928541 4.91443C0.937575 5.25948 1.03579 5.59634 1.21358 5.89221C1.39136 6.18808 1.6427 6.43282 1.94313 6.60278C2.24356 6.77274 2.58282 6.86208 2.92799 6.86206H4.91902C5.26419 6.86208 5.60351 6.77274 5.90394 6.60278C6.20438 6.43282 6.45565 6.18808 6.63344 5.89221C6.81122 5.59634 6.90944 5.25948 6.91847 4.91443C6.9275 4.56937 6.84707 4.22786 6.68501 3.9231L5.69002 2.05005C5.51974 1.72931 5.26532 1.46093 4.95412 1.2738C4.64291 1.08667 4.28667 0.987793 3.92354 0.987793C3.5604 0.987793 3.20411 1.08667 2.8929 1.2738C2.58169 1.46093 2.32727 1.72931 2.157 2.05005Z" />
        <path d="M11.924 6.92505C13.5809 6.92505 14.924 5.5819 14.924 3.92505C14.924 2.26819 13.5809 0.925049 11.924 0.925049C10.2672 0.925049 8.92401 2.26819 8.92401 3.92505C8.92401 5.5819 10.2672 6.92505 11.924 6.92505Z" />
        <path d="M13.075 8.77307H10.772C9.6674 8.77307 8.77197 9.6685 8.77197 10.7731V13.0761C8.77197 14.1806 9.6674 15.0761 10.772 15.0761H13.075C14.1795 15.0761 15.075 14.1806 15.075 13.0761V10.7731C15.075 9.6685 14.1795 8.77307 13.075 8.77307Z" />
        <path d="M6.56201 13.8601C6.60945 13.9052 6.64722 13.9595 6.67303 14.0197C6.69885 14.0798 6.71216 14.1446 6.71216 14.2101C6.71216 14.2756 6.69885 14.3403 6.67303 14.4005C6.64722 14.4607 6.60945 14.5149 6.56201 14.5601C6.4697 14.6543 6.34386 14.7082 6.21198 14.7101C6.14505 14.71 6.07881 14.6968 6.01703 14.671C5.95525 14.6453 5.89916 14.6075 5.85199 14.5601L3.922 12.63L1.992 14.5601C1.89969 14.6543 1.77391 14.7082 1.64203 14.7101C1.5751 14.71 1.5088 14.6968 1.44702 14.671C1.38524 14.6453 1.32915 14.6075 1.28198 14.5601C1.19037 14.4666 1.1391 14.341 1.1391 14.2101C1.1391 14.0792 1.19037 13.9536 1.28198 13.8601L3.22198 11.9301L1.28198 9.98999C1.19037 9.89653 1.1391 9.77089 1.1391 9.64001C1.1391 9.50914 1.19037 9.3835 1.28198 9.29004C1.32846 9.24317 1.38377 9.20605 1.4447 9.18066C1.50563 9.15528 1.57102 9.14209 1.63702 9.14209C1.70303 9.14209 1.76836 9.15528 1.82928 9.18066C1.89021 9.20605 1.94552 9.24317 1.992 9.29004L3.922 11.2201L5.85199 9.29004C5.89847 9.24317 5.95378 9.20605 6.01471 9.18066C6.07564 9.15528 6.14103 9.14209 6.20703 9.14209C6.27304 9.14209 6.33836 9.15528 6.39929 9.18066C6.46022 9.20605 6.51553 9.24317 6.56201 9.29004C6.60945 9.33516 6.64722 9.38942 6.67303 9.44958C6.69885 9.50975 6.71216 9.57454 6.71216 9.64001C6.71216 9.70548 6.69885 9.77028 6.67303 9.83044C6.64722 9.89061 6.60945 9.94487 6.56201 9.98999L4.63202 11.9301L6.56201 13.8601Z" />
      </svg>
    ),
    path: "/",
  },

  {
    name: "Profile",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z"
          
        />
        <path
          d="M4 10H12C13.0609 10 14.0783 10.4214 14.8284 11.1716C15.5786 11.9217 16 12.9391 16 14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14C0 12.9391 0.421427 11.9217 1.17157 11.1716C1.92172 10.4214 2.93913 10 4 10V10Z"
          
        />
      </svg>
    ),
    path: "/profile",
  },
  {
    name: "Settings",
    icon: (
      <svg
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.573 10.18C14.3227 9.83748 14.1878 9.42423 14.1878 9C14.1878 8.57577 14.3227 8.16253 14.573 7.82001L15.2129 6.946C15.4407 6.63314 15.5729 6.26092 15.5933 5.87447C15.6137 5.48801 15.5216 5.10393 15.3281 4.76878C15.1346 4.43364 14.848 4.16184 14.5031 3.98633C14.1582 3.81082 13.7698 3.73915 13.3849 3.78L12.308 3.897C11.8862 3.94254 11.4608 3.85276 11.0934 3.64064C10.7259 3.42852 10.4355 3.10505 10.264 2.717L9.82695 1.72501C9.66979 1.37155 9.41352 1.07125 9.08916 0.860489C8.7648 0.64973 8.38625 0.537552 7.99943 0.537552C7.61262 0.537552 7.23414 0.64973 6.90977 0.860489C6.58541 1.07125 6.32914 1.37155 6.17198 1.72501L5.73497 2.717C5.56347 3.10505 5.27299 3.42852 4.90556 3.64064C4.53813 3.85276 4.11278 3.94254 3.69096 3.897L2.61394 3.78C2.2291 3.73915 1.84068 3.81082 1.49577 3.98633C1.15086 4.16184 0.864328 4.43364 0.670822 4.76878C0.477316 5.10393 0.385184 5.48801 0.405624 5.87447C0.426065 6.26092 0.558154 6.63314 0.785934 6.946L1.42595 7.82001C1.67625 8.16253 1.81114 8.57577 1.81114 9C1.81114 9.42423 1.67625 9.83748 1.42595 10.18L0.785934 11.054C0.558154 11.3669 0.426065 11.7391 0.405624 12.1255C0.385184 12.512 0.477316 12.8961 0.670822 13.2312C0.864328 13.5664 1.15086 13.8382 1.49577 14.0137C1.84068 14.1892 2.2291 14.2609 2.61394 14.22L3.69096 14.103C4.11278 14.0575 4.53813 14.1472 4.90556 14.3594C5.27299 14.5715 5.56347 14.8949 5.73497 15.283L6.17198 16.274C6.32914 16.6275 6.58541 16.9278 6.90977 17.1385C7.23414 17.3493 7.61262 17.4615 7.99943 17.4615C8.38625 17.4615 8.7648 17.3493 9.08916 17.1385C9.41352 16.9278 9.66979 16.6275 9.82695 16.274L10.264 15.283C10.4355 14.8949 10.7259 14.5715 11.0934 14.3594C11.4608 14.1472 11.8862 14.0575 12.308 14.103L13.3849 14.22C13.7698 14.2609 14.1582 14.1892 14.5031 14.0137C14.848 13.8382 15.1346 13.5664 15.3281 13.2312C15.5216 12.8961 15.6137 12.512 15.5933 12.1255C15.5729 11.7391 15.4407 11.3669 15.2129 11.054L14.573 10.18ZM7.99895 11C7.60338 11 7.2167 10.8827 6.8878 10.6629C6.5589 10.4432 6.3026 10.1308 6.15123 9.76537C5.99985 9.39991 5.96023 8.99778 6.0374 8.60982C6.11457 8.22186 6.30506 7.86549 6.58476 7.58578C6.86447 7.30608 7.22085 7.11561 7.60881 7.03844C7.99677 6.96127 8.39888 7.00086 8.76433 7.15224C9.12978 7.30361 9.44215 7.55996 9.66191 7.88885C9.88167 8.21775 9.99895 8.60444 9.99895 9C9.99895 9.53043 9.78827 10.0391 9.41319 10.4142C9.03812 10.7893 8.52938 11 7.99895 11V11Z"
          
        />
      </svg>
    ),
    path: "/profile/edit",
  },
];

const BottomBar = () => {
  const location = useLocation();

  return (
    <>
      <div className="fixed bottom-0  left-0 w-full h-14 bg-white border-t border-transparent z-50  shadow-md flex sm:hidden  px-4  items-center">
        <ul className="relative w-full flex flex-row  justify-between gap-x-4">
          {BottomBarMenu.map((item, i) => (
            <li key={i} className="mobile-bottomBar-item">
              <Link
                to={item.path}
                className={`bottom-nav-link relative flex justify-center items-center   w-8 h-8 rounded-lg transition-all duration-300 ease-in-out ${
                  location.pathname === item.path &&
                  location.hash !== "#mycourses"
                    ? "bg-primary rounded-full stroke-light "
                    : location.hash === "#mycourses" &&
                      item.path === "/profile#mycourses"
                    ? "bg-primary rounded-full stroke-light"
                    : "bg-gray-100 fill"
                }`}
              >
                {item.icon}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default BottomBar;
